module.exports = __webpack_public_path__ + "static/media/icon6.1612f91d.png";